var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S from 's-js';
import { ConfigStore } from './configStore';
import { TokenStore } from './TokenStore';
import { Client, isAuthFailure } from './client';
import { AuthMonitor } from './authMonitor';
import { AuthClient } from './authClient';
import { HashSignal } from './hashSignal';
export const App = () => {
    const config = ConfigStore(), user = S.value(null), token = TokenStore(user), baseClient = Client(config.Server, token), isAuthenticated = () => !!token(), login = (u, p) => __awaiter(this, void 0, void 0, function* () { return user((yield baseClient.login.post(u, p)).user); }), logout = () => __awaiter(this, void 0, void 0, function* () { user(null); }), auth = AuthMonitor(isAuthenticated, isAuthFailure, login), client = AuthClient(baseClient, auth), location = HashSignal();
    return Object.assign({ user, isAuthenticated, login, logout }, auth, { location, client, init: init() });
    // request initial data, here just the user
    function init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!token())
                return;
            const resp = yield baseClient.user.get();
            user(resp.user);
        });
    }
};
